// extracted by mini-css-extract-plugin
export default {"formControlLabel":"RadioButtonsGroup_formControlLabel__Kxofb"};